@defer (hydrate never) {
    <footer class="footer-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="single-footer-widget mb-25">
                        <h3>Get in touch</h3>
                        <ul class="contact-us-link">
                            <li>
                                <i class='bx bx-map'></i>
                                <a href="https://maps.app.goo.gl/DPse7WDtHVtRL5ir7" rel="noopener noreferrer"
                                   target="_blank"><b>Mumbai</b>: Building No 28, 3rd Floor, Raj Bahadur Mansion, Mumbai
                                    Samachar Marg, opp. Allahabad Bank, Kala Ghoda, Fort, Mumbai, Maharashtra 400023</a>
                            </li>
                            <li>
                                <i class='bx bx-map'></i>
                                <a href="https://maps.app.goo.gl/Kk8s4jppKZBKqSqT6" rel="noopener noreferrer"
                                   target="_blank"><b>Jaipur</b>: N-98, Basement Office, Opp N-71 Rooms, opp. WTP Mall,
                                    Adinath Nagar, Jaipur, Rajasthan 302018</a>
                            </li>
                            <li>
                                <i class='bx bx-phone-call'></i>
                                <a href="tel:+919828430980">+919828430980</a>
                            </li>
                            <li>
                                <i class='bx bx-envelope'></i>
                                <a href="mailto:connect&#64;rooftopapp.com">connect&#64;rooftopapp.com</a>
                            </li>
                        </ul>
                        <ul class="social-link">
                            <li><a class="d-block" href="https://www.facebook.com/rooftopappdotcom"
                                   rel="noopener noreferrer" target="_blank" title="Rooftop Facebook Page"><i
                                class='bx bxl-facebook'></i></a></li>
                            <li><a class="d-block" href="https://www.youtube.com/c/RooftopApp"
                                   rel="noopener noreferrer" target="_blank" title="Rooftop Youtube Channel"><i
                                class='bx bxl-youtube'></i></a></li>
                            <li><a class="d-block" href="https://www.instagram.com/rooftop_app/"
                                   rel="noopener noreferrer" target="_blank" title="Rooftop Instagram Page"><i
                                class='bx bxl-instagram'></i></a></li>
                            <li><a class="d-block" href="https://www.linkedin.com/company/rooftopappcom/"
                                   rel="noopener noreferrer" target="_blank" title="Rooftop LinkedIn Company Page"><i
                                class='bx bxl-linkedin'></i></a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 offset-lg-1 col-md-4 col-sm-6">
                    <div class="single-footer-widget mb-25">
                        <h3>Support</h3>
                        <ul class="support-link">
                            <li><a routerLink="/faqs">FAQ's</a></li>
                            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li><a routerLink="/terms-and-conditions">Terms & Conditions</a></li>
                            <li><a routerLink="/cancellation-policy">Cancellation Policy</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                    <div class="single-footer-widget mb-25">
                        <h3>Useful Link</h3>
                        <ul class="useful-link">
                            <li><a routerLink="/about">About</a></li>
                            <li><a routerLink="/contact">Contact</a></li>
                            <li><a routerLink="/team">Team</a></li>
                            <li><a routerLink="/rooftop-for-corporates">Rooftop for Corporates</a></li>
                            <li><a routerLink="/thecircle">The Circle Archive</a></li>
                            <li><a routerLink="/sitemap">Sitemap</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="container">
                <p>Made with ❤️ at Rooftop</p>
            </div>
        </div>
    </footer>
}

<app-back-to-top/>
<app-whatsapp-support/>
